import { Box, Typography, Stack, ClickAwayListener, MenuItem, IconButton, RadioGroup, FormControlLabel, Radio, Button, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState, useEffect, useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getMethod, postMethod, putMethod } from "../../../../services/apiService";
import Loading from "../../../loading";
import { ToastContext, useToastContext } from "../../../../context/toastContext";
import { IconEyeOff } from '@tabler/icons-react';
import { IconEye } from '@tabler/icons-react';
interface BucketItem {
    name: string;
}

type StorageProps = {
    onSubmitRequest?: (fn: () => void) => void;
};

const Storage = ({ onSubmitRequest }: StorageProps) => {

    const { setToast } = useToastContext() as ToastContext;
    const [openStorageClass, setOpenStorageClass] = React.useState(false);
    const [openStorageType, setOpenStorageType] = React.useState(false);
    const [openRegionTypes, setOpenRegionTypes] = React.useState(false);
    const [openBucketListTypes, setOpenBucketListTypes] = React.useState(false);
    const [storageClass, setStorageClass] = useState<{ id: number; name: string }[]>([]);
    const [storageTypes, setStorageTypes] = useState<{ id: number; name: string }[]>([
        { id: 1, name: "Recording" },
        { id: 2, name: "Event" }
    ]);
    const [bucketType, setBucketType] = useState("1");
    const [bucketSearchCompleted, setBucketSearchCompleted] = React.useState(false);
    const [isBucketLoading, setIsBucketLoading] = useState(false);
    const [drivePath, setDrivePath] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showUsername, setShowUsername] = useState(false);
    const [selectedStorageClass, setSelectedStorageClass] = useState("Select");
    const [storageClassId, setStorageClassId] = useState<number | null>(null);
    const [selectedstorageTypeId, setSelectedstorageTypeId] = useState<number | null>(null);
    const [selectedStorageType, setSelectedStorageType] = useState(storageTypes[0].name);
    const [storageTypeId, setStorageTypeId] = useState<number | null>(storageTypes[0].id);
    const [selectedBucket, setSelectedBucket] = useState("Select");
    const [bucketName, setBucketName] = useState("");
    const [originalBucketName, setOriginalBucketName] = useState("");
    const [url, setUrl] = useState("");
    const [newBucketCreated, setNewBucketCreated] = useState(false);
    const [existingStorages, setExistingStorages] = useState<any[]>([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [newBucketCreating, setNewBucketCreating] = useState(false);
    const awsRegions =
        ["ap-south-1",
            "eu-south-1",
            "us-gov-east-1",
            "ca-central-1",
            "eu- central-1",
            "us-west-1",
            "us-west-2",
            "af-south-1",
            "eu-north-1",
            "eu-west-3",
            "eu- west-2",
            "eu-west-1",
            "ap-northeast-2",
            "ap-northeast-1",
            "me-south-1",
            "sa-east-1",
            "ap-east-1",
            "cn-north-1",
            "us-gov-west-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "us- iso-east-1",
            "us-east-1",
            "us-east-2",
            "cn-northwest-1",
            "us-isob-east-1",
            "aws- global",
            "aws-cn-global",
            "aws-us-gov-global",
            "aws-iso-global",
            "aws-iso-b-global",
            "custom"
        ]
    const [selectedRegion, setSelectedRegion] = useState(awsRegions[0]);
    const [bucketList, setBucketList] = useState<BucketItem[]>([]);
    const [noStorageAdded, setNoStorageAdded] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    const toggleUsernameVisibility = () => {
        setShowUsername(prev => !prev);
    };

    const [driveInfo, setDriveInfo] = useState<{ totalStorageInGb: number | string; freeStorageInGb: number | string }>({
        totalStorageInGb: "",
        freeStorageInGb: ""
    });

    const isSaveDisabled =
        !password ||
        !username ||
        (bucketType === "1" && (!bucketName || !newBucketCreated)) ||
        (bucketType === "2" && selectedBucket == "Select");

    useEffect(() => {
        if (isEditMode) {
            setOriginalBucketName(bucketName);
        }
    }, [isEditMode]);

    const isBucketNameChanged =
        isEditMode && bucketName !== originalBucketName;

    const isEditDisabled =
        !password ||
        !username ||
        (bucketType === "1" && (!bucketName || isBucketNameChanged)) ||
        (bucketType === "2" && selectedBucket == "Select");

    const toggleStorageClassDropdown = () => {
        setOpenStorageClass(!openStorageClass);
    };

    const toggleStorageTypeDropdown = () => {
        setOpenStorageType(!openStorageType);
    };

    const toggleRegionTypeDropdown = () => {
        setOpenRegionTypes(!openRegionTypes);
    };

    const toggleBucketTypeDropdown = () => {
        setOpenBucketListTypes(!openBucketListTypes);
    };

    const getStorageTypes = async () => {
        const resp = await getMethod(`resource/storage/class`);
        if (resp?.data?.code === 200 && resp?.data?.result?.[0]) {
            const data = resp?.data?.result[0];
            const storageArray = Object.entries(data)
                .map(([id, name]) => ({
                    id: Number(id),
                    name: name as string,
                }))
                .filter(item => item.id !== 0 && item.id !== 3);
            setStorageClass(storageArray);

            if (isEditMode && storageClassId) {
                const matchedClass = storageArray.find(
                    cls => cls.id === storageClassId
                );

                if (matchedClass) {
                    setSelectedStorageClass(matchedClass.name);
                    setStorageClassId(matchedClass.id);
                    return;
                }
            }

            else {
            setSelectedStorageClass(storageArray[0]?.name);
            setStorageClassId(storageArray[0]?.id);
            }
        }
    };

    const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    const getBucketList = async () => {
        setIsBucketLoading(true);
        let payload = {
            "password": password,
            "username": username,
            "serviceEndpoint": url,
            "storageclasstype": storageClassId,
            "bucketListSessionId": Date.now(),
            "region": selectedRegion,
            "storagetype": storageTypeId,
        }

        let maxRetries = 100;
        let retryCount = 0;
        let pollingInterval = 1000;
        let allResults: BucketItem[] = [];

        while (retryCount < maxRetries) {
            const resp = await postMethod(`resource/storage/buckets`, payload);

            if (resp?.data?.status === 200) {
                // debugger
                const currentResult: BucketItem[] = resp?.data?.result ?? [];
                // setBucketList(prev => [...prev, ...currentResult]);

                setBucketList(prev => {
                    const prevSet = new Set(prev);
                    currentResult.forEach(item => prevSet.add(item));
                    return Array.from(prevSet);
                });
            }

            if (
                resp?.data?.status === 200 &&
                resp?.data?.code === 4017
            ) {
                setBucketSearchCompleted(true);
                setIsBucketLoading(false);
                setToast("Bucket Search Completed", "success");
                return;
            }
            else if (resp?.data?.status !== 200) {
                setBucketSearchCompleted(true);
                setIsBucketLoading(false);
                setToast(resp?.data?.message, "error");
                return;
            }

            retryCount++;
            await sleep(pollingInterval);
        }
    };

    const hasFetchedRef = useRef(false);
    useEffect(() => {
        if (hasFetchedRef.current) return;
        hasFetchedRef.current = true;
        getStorageTypes();
        getPlatformStorage();
    }, [])

    const createNewBucket = async () => {
        setNewBucketCreating(true);
        let payload = {
            "password": password,
            "username": username,
            "storageclasstype": storageClassId,
            "path": bucketName,
            "region": selectedRegion,
            "storagetype": storageTypeId,
            "serviceEndpoint": url
        }
        const resp = await postMethod(`resource/storage/create-bucket`, payload);

        if (resp?.data?.status === 200) {
            setNewBucketCreating(false);
            setNewBucketCreated(true);
            setOriginalBucketName(bucketName);
            setToast("Bucket Created Successfully", "success");
        }
        // else if (resp?.data?.code === 4015)
        //     setToast
        else {
            setNewBucketCreating(false);
            setToast(resp?.data?.message, "error");
        }
        return
    };

    const savePlatformStorage = async () => {
        let payload = {
            "password": password,
            "username": username,
            "storageclasstype": storageClassId,
            "path": bucketType == "1" ? bucketName : selectedBucket,
            "region": selectedRegion,
            "storagetype": storageTypeId,
            "serviceEndpoint": url,
        }
        let payload_Edit = {
            "id": selectedstorageTypeId,
            "password": password,
            "username": username,
            "storageclasstype": storageClassId,
            "path": bucketType == "1" ? bucketName : selectedBucket,
            "region": selectedRegion,
            "storagetype": storageTypeId,
            "serviceEndpoint": url,
        }
        let resp;

        if (isEditMode) {
            resp = await putMethod(`resource/storage`, payload_Edit);
        } else {
            resp = await postMethod(`resource/storage`, payload);
        }

        if (resp?.data?.status === 200 && resp?.data?.result) {
            setToast(isEditMode ? "Storage Updated Successfully" : "Storage Added Successfully", "success");
            getPlatformStorage();
            // const currentResult: BucketItem[] = [resp.data.result];
            // setBucketList(prev => [...prev, ...currentResult]);
        }
        else
            setToast(resp?.data?.message, "error");
        // if (
        //     resp?.data?.status === 200 &&
        //     resp?.data?.code === 4017
        // ) {
        //     setBucketSearchCompleted(true);
        //     return;
        // }
    };

    const getPlatformStorage = async () => {
        const resp = await getMethod(`resource/storage`);

        if (resp?.data?.status === 200) {
            setExistingStorages(resp.data.result);

        }
        else {
            setToast(resp?.data?.message, "error");
            setExistingStorages([]);
        }
    };

    const applyStorageByType = (storageTypeId: number) => {

        const matchedStorage = existingStorages.find(
            s => s.storagetype === storageTypeId //Change here to storagetype
        );

        if (matchedStorage) {
            setIsEditMode(true);

            // populate fields
            setStorageTypeId(storageTypeId);

            const matchedType = storageTypes.find(t => t.id === storageTypeId);
            setSelectedStorageType(matchedType?.name || "");

            setStorageClassId(matchedStorage.storageclasstype);

            const matchedClass = storageClass.find(
                c => c.id === matchedStorage.storageclasstype
            );
            setSelectedStorageClass(matchedClass?.name || "");

            setSelectedRegion(
                awsRegions.includes(matchedStorage.region)
                    ? matchedStorage.region
                    : awsRegions[0]
            );

            setUrl(matchedStorage.serviceEndpoint);
            setUsername(matchedStorage.username);
            setPassword(matchedStorage.password);
            setBucketName(matchedStorage.path);
            setSelectedBucket(matchedStorage.path);
            setOriginalBucketName(matchedStorage.path);
            setSelectedstorageTypeId(matchedStorage.id);
        } else {
            // CREATE MODE
            setIsEditMode(false);

            setStorageTypeId(storageTypeId);

            const matchedType = storageTypes.find(t => t.id === storageTypeId);
            setSelectedStorageType(matchedType?.name || "");

            // reset fields
            setBucketType("1");
            setBucketList([]);
            setUrl("");
            setUsername("");
            setPassword("");
            setBucketName("");
            // setSelectedBucket("");
            setSelectedBucket("Select")
            setBucketSearchCompleted(false);


            setSelectedRegion(awsRegions[0]);
            setSelectedStorageClass(storageClass[0]?.name || "");
            setStorageClassId(storageClass[0]?.id || null);
        }
    };

    useEffect(() => {
        if (existingStorages.length > 0) {
            const preferred =
                existingStorages.find(s => s.storagetype === 1) ||  //change here
                existingStorages.find(s => s.storagetype === 2); //change here

            if (storageTypeId) {
                applyStorageByType(storageTypeId); //change here
            }
        }
    }, [existingStorages]);


    useEffect(() => {
        onSubmitRequest?.(savePlatformStorage);
    }, [onSubmitRequest]);

    useEffect(() => {
        if (!selectedRegion) return;

        // AWS 
        if (storageClassId === 1) {
            setUrl(`https://s3.${selectedRegion}.amazonaws.com`);
            return;
        }

        // WASABI 
        if (storageClassId === 2) {
            setUrl(`https://s3.${selectedRegion}.wasabisys.com`);
            return;
        }
        // S3 NAS
        if (!isEditMode && storageClassId === 4) {
            setUrl("");
            return;
        }

        // storageClassId === 4 → manual input
    }, [storageClassId, selectedStorageClass, selectedRegion]);

    //For bucket naming rule 
    const isLengthValid = (name: string) => name.length >= 3 && name.length <= 63;

    const isCharValid = (name: string) =>
        /^[a-z0-9.-]+$/.test(name);

    const hasNoAdjacentPeriodsOrPeriodHyphen = (name: string) =>
        !(/(\.\.)|(\.-)|(-\.)/.test(name));

    const isNotIPAddress = (name: string) =>
        !/^(\d{1,3}\.){3}\d{1,3}$/.test(name);

    const hasNoXnPrefix = (name: string) =>
        !name.startsWith("xn--");

    const hasNoS3AliasSuffix = (name: string) =>
        !name.endsWith("-s3alias");

    const bucketRules = [
        {
            text: "Must be between 3 (min) and 63 (max) characters long.",
            check: isLengthValid,
        },
        {
            text: "Can consist only of lowercase letters, numbers, dots (.), and hyphens (-).",
            check: isCharValid,
        },
        {
            text: "Must not contain two adjacent periods, or a period adjacent to a hyphen.",
            check: hasNoAdjacentPeriodsOrPeriodHyphen,
        },
        {
            text: "Must not be formatted as an IP address (for example, 192.168.5.4).",
            check: isNotIPAddress,
        },
        {
            text: "Must not start with the prefix xn--.",
            check: hasNoXnPrefix,
        },
        {
            text: "Must not end with the suffix -s3alias. This suffix is reserved for access point alias names.",
            check: hasNoS3AliasSuffix,
        },
    ];

    const isBucketNameValidByAllRules =
        bucketName.length > 0 &&
        bucketRules.every(rule => rule.check(bucketName));

    return (
        // <Box height={'600px'}>

        <Box sx={{ position: 'relative' }}>
            <form
                style={
                    {
                        // height: `${errors.priority === "" ? '282px' : '302px'}`,
                        overflowY: "auto",
                        // marginTop: "24px",
                        scrollbarWidth: "none",
                        "-ms-overflow-style": "none",
                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                    } as any
                }
            >
                <div style={{ display: "flex", gap: "20px" }}>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="sitesBox" className="modalForm-label">
                            Storage Type
                        </label>{" "}
                        <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="space-between"
                            className="modalForm-input"
                            style={{
                                // marginBottom: "-10px",
                                cursor: "pointer",
                                background: '#192529'
                            }}
                            onClick={toggleStorageTypeDropdown}
                        >
                            <span className="selectedValue">
                                {selectedStorageType}
                            </span>
                            <ExpandMoreIcon
                                sx={{
                                    cursor: "pointer",
                                    color: "#B4B7B8",
                                    fontSize: "24px",
                                    display: "inline-block",
                                    transition: "0.5s",
                                }}
                            />
                        </Stack>
                        <br />

                        {openStorageType && (
                            <ClickAwayListener onClickAway={() => setOpenStorageType(false)}>
                                <div
                                    className="modalForm-menu"
                                    id="sitesBox"
                                    style={{
                                        position: 'absolute',
                                        width: '50%',
                                        minHeight: '85px',
                                        overflowY: 'auto',
                                        scrollbarWidth: 'none',
                                        zIndex: 9,
                                        backgroundColor: '#1F2F34',
                                        borderRadius: '8px',
                                        padding: '8px 0',
                                    }}
                                >
                                    {storageTypes.map(type => {
                                        const alreadyExists = existingStorages.some(
                                            s => s.storageTypeId === type.id
                                        );

                                        return (
                                            <MenuItem
                                                key={type.id}
                                                disabled={alreadyExists && !isEditMode}
                                                onClick={() => {
                                                    applyStorageByType(type.id);
                                                    setOpenStorageType(false);
                                                }}
                                            >
                                                {type?.name}
                                            </MenuItem>
                                        );
                                    })}

                                </div>
                            </ClickAwayListener>
                        )}
                        {/* {errors.priority && <div className="dropdown-error-message">{errors.priority}</div>} */}
                    </div>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="sitesBox" className="modalForm-label">
                            Storage Class
                        </label>{" "}
                        <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="space-between"
                            className="modalForm-input"
                            style={{
                                // marginBottom: "-10px",
                                cursor: isEditMode ? "not-allowed" : "pointer",
                                background: '#192529',
                                opacity: isEditMode ? 0.5 : 1
                            }}
                            onClick={() => {
                                if (isEditMode) return
                                toggleStorageClassDropdown();
                            }}


                        >
                            <span className="selectedValue">
                                {selectedStorageClass}
                            </span>
                            <ExpandMoreIcon
                                sx={{
                                    cursor: "pointer",
                                    color: "#B4B7B8",
                                    fontSize: "24px",
                                    display: "inline-block",
                                    transition: "0.5s",
                                }}
                            />
                        </Stack>
                        <br />

                        {openStorageClass && (
                            <ClickAwayListener onClickAway={() => setOpenStorageClass(false)}>
                                <div
                                    className="modalForm-menu"
                                    id="sitesBox"
                                    style={{
                                        position: 'absolute',
                                        width: '50%',
                                        minHeight: '120px',
                                        overflowY: 'auto',
                                        scrollbarWidth: 'none',
                                        zIndex: 9,
                                        backgroundColor: '#1F2F34',
                                        borderRadius: '8px',
                                        padding: '8px 0',
                                    }}
                                >
                                    {storageClass?.map((type: any, index) => (
                                        <MenuItem
                                            key={type?.id}
                                            value={type?.id}
                                            onClick={() => {
                                                setSelectedStorageClass(type?.name);
                                                setStorageClassId(type.id);
                                                setOpenStorageClass(false);
                                            }}
                                            sx={{ color: '#fff', padding: '10px 16px' }}

                                        >
                                            {type?.name}
                                        </MenuItem>
                                    ))}
                                </div>
                            </ClickAwayListener>
                        )}
                        {/* {errors.priority && <div className="dropdown-error-message">{errors.priority}</div>} */}
                    </div>
                </div>

                <div style={{ display: "flex", gap: "20px" }}>
                    {storageClassId !== 4 &&
                        <div style={{ flex: "1" }}>
                            <label htmlFor="sitesBox" className="modalForm-label">
                                Region
                            </label>{" "}
                            <Stack
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                justifyContent="space-between"
                                className="modalForm-input"
                                style={{
                                    // marginBottom: "-10px",
                                    cursor: "pointer",
                                    background: '#192529'
                                }}
                                onClick={toggleRegionTypeDropdown}
                            >
                                <span className="selectedValue">
                                    {selectedRegion}
                                </span>
                                <ExpandMoreIcon
                                    sx={{
                                        cursor: "pointer",
                                        color: "#B4B7B8",
                                        fontSize: "24px",
                                        display: "inline-block",
                                        transition: "0.5s",
                                    }}
                                />
                            </Stack>
                            <br />

                            {openRegionTypes && (
                                <ClickAwayListener onClickAway={() => setOpenRegionTypes(false)}>
                                    <div
                                        className="modalForm-menu"
                                        id="sitesBox"
                                        style={{
                                            position: 'absolute',
                                            width: '50%',
                                            maxHeight: '350px',
                                            overflowY: 'scroll',
                                            scrollbarWidth: 'none',
                                            zIndex: 9,
                                            backgroundColor: '#1F2F34',
                                            borderRadius: '8px',
                                            padding: '8px 0',
                                        }}
                                    >
                                        {awsRegions.map((type: any, index) => (
                                            <MenuItem
                                                key={index}
                                                value={type}
                                                onClick={() => {
                                                    setSelectedRegion(type);
                                                    // setStorageClassId(type.id);
                                                    setOpenRegionTypes(false);
                                                }}
                                                sx={{ color: '#fff', padding: '10px 16px' }}
                                            >
                                                {type}
                                            </MenuItem>
                                        ))}
                                    </div>
                                </ClickAwayListener>
                            )}
                            {/* {errors.priority && <div className="dropdown-error-message">{errors.priority}</div>} */}
                        </div>
                    }

                    <div style={{ flex: "1", marginBottom: "20px" }}>
                        <label htmlFor="sitesBox" className="modalForm-label">
                            Service Endpoint<span style={{ color: "red" }}>{storageClassId == 4 ? "*" : "" }</span>
                        </label>
                        <input
                            type="text"
                            id="url"
                            placeholder="Enter Endpoint"
                            className="modalForm-input"
                            name="url"
                            readOnly={storageClassId !== 4}
                            style={{
                                background: '#192529',
                                cursor: storageClassId === 4 ? 'text' : 'not-allowed',
                                opacity: storageClassId === 4 ? 1 : 0.5
                            }}
                            value={url}
                            onChange={(e) => {
                                if (storageClassId === 4) { setUrl(e.target.value) }
                            }}
                        />
                    </div>
                </div>



                <style>
                    {`
                                .modalForm-input::placeholder {
                                    color: #606161;
                                    font-size: 13px;
                                }
                            `}
                </style>

                <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="username" className="modalForm-label">
                            Access Key ID<span style={{ color: "red" }}>*</span>
                        </label>
                        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                            <input
                                type={showUsername ? 'text' : 'password'}
                                // type="text"
                                id="username"
                                placeholder="Enter Access Key ID"
                                className="modalForm-input"
                                name="username"
                                autoComplete="new-password"
                                style={{ background: '#192529' }}
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                            {username && (
                                <IconButton
                                    onClick={toggleUsernameVisibility}
                                    sx={{
                                        position: 'absolute',
                                        right: '10px',
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        cursor: 'pointer'
                                    }}
                                >
                                    {showUsername ? (
                                        // <img src="/closed-eye.svg" alt="Icon" />
                                        <IconEyeOff stroke={1.4} color="#B4B7B8" />
                                    ) : (
                                        // <img src="/open-eye.svg" alt="Icon" />
                                        <IconEye stroke={1.4} color="#B4B7B8"/>
                                    )}
                                </IconButton>

                            )}
                        </div>
                    </div>

                    <div style={{ flex: 1 }}>
                        <label htmlFor="password" className="modalForm-label">
                            Secret Access Key<span style={{ color: "red" }}>*</span>
                        </label>
                        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                placeholder="Enter Secret Access Key"
                                className="modalForm-input"
                                name="password"
                                autoComplete="new-password"
                                style={{
                                    background: '#192529',
                                    paddingRight: '40px'
                                }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {password && (
                                <IconButton
                                    onClick={togglePasswordVisibility}
                                    sx={{
                                        position: 'absolute',
                                        right: '10px',
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        cursor: 'pointer'
                                    }}
                                >
                                    {showPassword ? (
                                        // <img src="/closed-eye.svg" alt="Icon" />
                                        <IconEyeOff stroke={1.4} color="#B4B7B8" />
                                    ) : (
                                        // <img src="/open-eye.svg" alt="Icon" />
                                        <IconEye stroke={1.4} color="#B4B7B8"/>
                                    )}
                                </IconButton>

                            )}
                        </div>
                    </div>
                </div>


                <div style={{ display: "flex", gap: "16px", marginBottom: "4px" }}>
                    <div style={{ flex: 1 }}>
                        <label htmlFor="username" className="modalForm-label">
                            Bucket
                        </label>
                        <Box sx={{
                            mb: 2,
                            mt: 1,
                            backgroundColor: "#293236",
                            borderRadius: "30px",
                            color: "#E2E3E3",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            // justifyContent: "space-between",
                            px: 2
                        }}>

                            <RadioGroup
                                name="validity"
                                row
                                value={bucketType}
                                onChange={(e: any) => { setBucketType(e.target.value); setBucketSearchCompleted(false); setSelectedBucket("Select")}}
                            >
                                <FormControlLabel value="1" control={<Radio />} label="New Bucket" />
                                <FormControlLabel value="2" control={<Radio />} label="Existing Bucket" />
                            </RadioGroup>

                        </Box>
                    </div>
                </div>

                <div style={{ display: "flex", gap: "20px" }}>
                    {bucketType == "2" && bucketSearchCompleted && bucketList.length !== 0 &&
                        <div style={{ flex: "1" }}>
                            <label htmlFor="sitesBox" className="modalForm-label">
                                Bucket List<span style={{ color: "red" }}>*</span>
                            </label>{" "}
                            <Stack
                                display="flex"
                                flexDirection="row"
                                alignItems="center"
                                justifyContent="space-between"
                                className="modalForm-input"
                                style={{
                                    cursor: bucketSearchCompleted ? "pointer" : "not-allowed",
                                    opacity: bucketSearchCompleted ? 1 : 0.5,
                                    pointerEvents: bucketSearchCompleted ? "auto" : "none",
                                    background: "#192529",

                                }}
                                onClick={bucketSearchCompleted ? toggleBucketTypeDropdown : undefined}
                                aria-disabled={!bucketSearchCompleted}
                            >
                                <span className="selectedValue">
                                    {selectedBucket}
                                </span>
                                <ExpandMoreIcon
                                    sx={{
                                        cursor: bucketSearchCompleted ? "pointer" : "not-allowed",
                                        color: "#B4B7B8",
                                        fontSize: "24px",
                                        display: "inline-block",
                                        transition: "0.5s",
                                    }}
                                />
                            </Stack>
                            {/* <br /> */}

                            {openBucketListTypes && (
                                <ClickAwayListener onClickAway={() => setOpenBucketListTypes(false)}>
                                    <div
                                        className="modalForm-menu"
                                        id="sitesBox"
                                        style={{
                                            position: 'absolute',
                                            width: '100%',
                                            // minHeight: '120px',
                                            // overflowY: 'auto',
                                            // scrollbarWidth: 'none',
                                            maxHeight: '225px',
                                            overflowY: 'auto',
                                            scrollbarWidth: 'thin',
                                            bottom: '15%',
                                            marginBottom: '8px',
                                            zIndex: 9,
                                            backgroundColor: '#1F2F34',
                                            borderRadius: '8px',
                                            padding: '8px 0',
                                        }}
                                    >
                                        {bucketList.map((type: any, index) => (
                                            <MenuItem
                                                key={index}
                                                value={type}
                                                onClick={() => {
                                                    setSelectedBucket(type);
                                                    // setStorageClassId(type.id);
                                                    setOpenBucketListTypes(false);
                                                }}
                                                sx={{ color: '#fff', padding: '10px 16px' }}
                                            >
                                                {type}
                                            </MenuItem>
                                        ))}
                                    </div>
                                </ClickAwayListener>
                            )}
                        </div>
                    }

                    {bucketType == "2" &&
                        <div style={{ flex: "1" }}>
                            <button
                                type="button"
                                className="outline-btn-disable"
                                style={{
                                    cursor: !username || !password || !url ? "not-allowed" : "pointer", marginLeft: "0px", display: "flex", alignItems: "center",
                                    marginTop: bucketSearchCompleted && bucketList.length != 0? "35px" : "0px", padding: "12px 16px"
                                }}
                                onClick={() => {
                                    getBucketList();
                                }}
                                disabled={!username || !password || !url}
                            >
                                {isBucketLoading ? "Fetching Buckets" : "Fetch Buckets"}
                                {isBucketLoading &&
                                    <CircularProgress color={"info"} size={20} style={{ marginLeft: "8px" }} />
                                }
                            </button>
                        </div>
                    }

                </div>

                {bucketList.length == 0 && bucketSearchCompleted && <div style={{ color: "red", fontSize: "14px", marginTop: "4px", marginLeft: "8px" }}>{"No Bucket Found"}</div>}


                <div style={{ display: "flex", gap: "20px" }}>
                    {bucketType == "1" &&
                        <div style={{ flex: "1"}}>
                            <label htmlFor="sitesBox" className="modalForm-label">
                                Bucket Name<span style={{ color: "red" }}>*</span>
                            </label>{" "}
                            <input
                                type="text"
                                id="bucketname"
                                placeholder="Enter Bucket Name"
                                className="modalForm-input"
                                name="bucketname"
                                // autoComplete="new-password"
                                style={{ background: '#192529' }}
                                value={bucketName}
                                onChange={(e) => {
                                    setBucketName(e.target.value);
                                    if (e.target.value !== originalBucketName) {
                                        setNewBucketCreated(false);
                                    }
                                }}
                            />
                            

                        </div>
                    }

                    <Box sx={{ flex: 1, marginTop: "30px", marginBottom: "10px" }}>
                        {bucketType === "1" && (
                            <button
                                type="button"

                                className="outline-btn-disable"
                                onClick={createNewBucket}
                                disabled={!bucketName ||
                                    newBucketCreating ||
                                    (newBucketCreated && bucketName === originalBucketName) || !isBucketNameValidByAllRules} 
                            >
                                Create New Bucket
                                {newBucketCreating &&
                                    <CircularProgress color={"primary"} size={20} style={{ marginLeft: "8px" }} />
                                }
                            </button>
                        )}
                        
                    </Box>
                </div>

                 {bucketType === "1" && <div>
                    <span style={{ fontSize: "14px", fontWeight: 500, gap: "4px" }}>
                        {bucketRules.map((rule, index) => {
                            const isValid = bucketName ? rule.check(bucketName) : false;

                            return (
                                <span
                                    key={index}
                                    style={{
                                        display: "block",
                                        marginTop: index === 0 ? "12px" : "2px",
                                        color: isValid ? "#07A25C" : "#3D484D",
                                    }}
                                >
                                    <img
                                        src={
                                            isValid
                                                ? "/icons/rule_check.svg"
                                                : "/icons/rule_cross.svg"
                                        }
                                        alt="rule status"
                                        width={13}
                                        height={13}
                                        style={{ marginRight: "6px" }}
                                    />
                                    {rule.text}
                                </span>
                            );
                        })}
                    </span>
                </div>}
            </form>

            <Grid size={{ xs: 12 }}>
                <hr
                    style={{
                        border: "none",
                        height: "1px",
                        color: "#313838",
                        backgroundColor: "#313838",
                        margin: "8px 0 30px 0",
                    }}
                />
            </Grid>
            {/* Right section */}
            <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end", marginTop: "40px" }}>
                <Button
                    type="button"
                    variant="contained"
                    className="btnBlue"
                    sx={{
                        color: "#1F2F34",
                        height: "41px",
                        lineHeight: "41px",
                        background: "#0B4A62",
                        "&:hover": {
                            background: "#0E607D",
                        },
                        "&.Mui-disabled": {
                            backgroundColor: "#B0BEC5 !important",
                            color: "#6B7280",
                            cursor: "not-allowed !important",
                        },
                        borderRadius: "30px",
                        fontWeight: "500",
                        textTransform: "none"
                    }}
                    onClick={savePlatformStorage}
                    disabled={isEditMode ? isEditDisabled : isSaveDisabled}
                >
                    {isEditMode ? "Update" : "Save"}
                </Button>
            </Box>

        </Box>
    );
};

export default Storage;